import styled from 'styled-components'

export const LogInProviderButton = styled.div`
  padding-left: 8px;
  width: 270px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  font-size: ${props => props.theme.fontSizeMedium};
  height: 40px;
  border-radius: 10px;
  text-decoration: none;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const EmailProviderButton = styled(LogInProviderButton)`
  background-color: ${props => props.theme.colors.orange};
  color: ${props => props.theme.colors.white};
  box-shadow: 0 0 0 1px ${props => props.theme.colors.orange};
`

export const GoogleProviderButton = styled(LogInProviderButton)`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.darkGray};
  box-shadow: 0 0 0 1px ${props => props.theme.colors.darkGray};
`

export const FacebookProviderButton = styled(LogInProviderButton)`
  background-color: ${props => props.theme.colors.facebookBlue};
  color: ${props => props.theme.colors.white};
  box-shadow: 0 0 0 1px ${props => props.theme.colors.facebookBlue};
`

export const AppleProviderButton = styled(LogInProviderButton)`
  background-color: ${props => props.theme.colors.appleBlack};
  color: ${props => props.theme.colors.white};
  box-shadow: 0 0 0 1px ${props => props.theme.colors.appleBlack};
`

export const LogInProviderButtonIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 22px;
`

export const LogInProviderButtonIconImage = styled.img`
  width: 22px;
  height: 22px;
`

export const LogInProviderButtonContent = styled.div`
  text-decoration: none;
`
